import PropTypes from 'prop-types';
import React from 'react';
import HouseholdCountDisplay from './HouseholdCountDisplay';
import emptyAndNonZero from '../../utils/emptyAndNonZero';
import { get } from 'lodash';
var UnknownHouseholdCount = function UnknownHouseholdCount(_ref) {
  var householdCount = _ref.householdCount;
  var total = get(householdCount, 'total', 0);
  var adults = get(householdCount, 'adults', 0);
  var children = get(householdCount, 'children', 0);
  var diff = total - (adults + children);
  if (emptyAndNonZero(total) || emptyAndNonZero(adults) || emptyAndNonZero(children)) {
    return null;
  }
  if (diff === 0) {
    return null;
  }
  return diff !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "col-xs-4 unknown-household-count"
  }, /*#__PURE__*/React.createElement(HouseholdCountDisplay, {
    label: "Unknown",
    value: diff
  }));
};
UnknownHouseholdCount.propTypes = {
  householdCount: PropTypes.object.isRequired
};
export default UnknownHouseholdCount;
//# sourceMappingURL=UnknownHouseholdCount.js.map